import treatmentObjectFragment from "../fragments/treatmentObject";

const treatmentAdjustmentQuery2 = `treatmentAdjustments2[]
${treatmentObjectFragment}
`;

export default treatmentAdjustmentQuery2;
